'use client'
import { escapeHTML } from '@utils/validations'
import { useRouter, useSearchParams } from 'next/navigation'
import { create } from 'zustand'

interface DiscoveryStore {
  input: string
  setInput: (input: string) => void
  ID: string
  setID: (id: string | null) => void
}

const search = typeof window === 'undefined' ? '' : (new URLSearchParams(window.location.search).get('search') ?? '')

export const useDiscoveryStore = create<DiscoveryStore>(set => ({
  input: search ? escapeHTML(search) : '',
  setInput: input => set({ input }),
  ID: null,
  setID: id =>
    set({
      ID: id
    })
}))

export const useDiscoveryStoreActions = () => {
  const router = useRouter()
  const search = useSearchParams()
  const focused = search.has('discovery')

  const open = () => {
    const params = new URLSearchParams(search.toString())
    params.set('discovery', '')
    router.push(`?${params.toString()}`)
  }

  // Dismisses the whole surface, the panel and the menu drawer behind it, in a
  // single URL update. Params are matched on name alone because hosts deep-link
  // in with `discovery=true`.
  const close = () => {
    const params = new URLSearchParams(search.toString())
    params.delete('discovery')
    params.delete('menu')
    router.replace(`?${params.toString()}`)
  }

  return {
    isOpen: focused,
    open,
    close
  }
}
